/**
 * bucket模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const bucket = {
  //分页
  pageBrokerSummary(params) {
    return $http.post(`${global.API_URL}/sme/bucket/page`,params);
  },
  //折线图
  queryBucketIndex(params) {
    return $http.post(`${global.API_URL}/sme/bucket/queryBucketIndex`,params);
  },
  //详情
  queryBucketByName(params) {
    return $http.post(`${global.API_URL}/sme/bucket/queryBucketByName`,params);
  },
   //删除
   deleteOss(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/bucket/delete`,param);
  },
}

export default bucket;



// WEBPACK FOOTER //
// ./src/api/bucket.js